import { Alert } from "antd";
import qs from "query-string";
import { useEffect, useState } from "react";
import { UNKNOWN_ERROR_MESSAGE } from "../constants";
import { persistLinkState } from "../hooks/useLinkTracker";
import { captureException } from "../sentry";
import Store from "../stateStore";
import { extractLinkParamsFromState, getBackendUrl, STORES } from "../utils";

type MercadoLibreProps = {
  clientSecret: string;
  onBack: () => void;
  onCancel: () => void;
  onComplete: (publicToken: string) => void;
};

function MercadoLibre({
  clientSecret,
  onBack,
  onCancel,
  onComplete,
}: MercadoLibreProps) {
  const store = Store.useStore();
  const [error, setError] = useState<string>("");

  useEffect(() => {
    handleComplete();
  });

  function handleAuthError(e: any) {
    captureException(e);
    if (e.response.data.error_message) {
      setError(e.response.data.error_message);
    } else {
      setError(UNKNOWN_ERROR_MESSAGE);
    }
  }

  function handleComplete() {
    try {
      persistLinkState(STORES.MERCADOLIBRE, store.getState());
      const q = qs.stringify(extractLinkParamsFromState(store));
      const url = `${getBackendUrl()}/mercadoLibre/proxy/app-url?${q}`;
      window.location.replace(url);
    } catch (e) {
      handleAuthError(e);
    }
  }

  return (
    <>
      {error && (
        <Alert
          className="mt-4"
          type="error"
          message={"Error"}
          description={error}
          showIcon
        />
      )}
    </>
  );
}

export default MercadoLibre;
